import fetchWithTimeout from "./fetchAPI";

const getFilteredLogs = async (token, filters) => {
  const headers = new Headers();
  headers.append("token", token);
  headers.append('Content-Type', 'application/json');
  const path = "getFilteredLogs";
  const results = await fetchWithTimeout(
    path,
    {
      method: "POST",
      headers: headers,
      body: JSON.stringify(filters),
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
    },
    7000
  );

  const jsonResults = await results.json();
  return jsonResults;
};

const getMessageTypes = async (token, filters) => {
  const headers = new Headers();
  headers.append("token", token);
  headers.append('Content-Type', 'application/json');
  const path = "getMessageTypes";
  const results = await fetchWithTimeout(
    path,
    {
      method: "POST",
      headers: headers,
      body: JSON.stringify(filters),
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
    },
    7000
  );

  const jsonResults = await results.json();
  return jsonResults;
};

export { getFilteredLogs, getMessageTypes };
